/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useRef, useState } from "react";
//#endregion
//#region Styles
import {
    BodyRowText, 
    StudentCell, 
    StateCell, 
    SelectionCell } from "./styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
//#endregion
//#region Icons
import UserIcon2 from "icons/UserIcon2";
import WarningIcon from "icons/WarningIcon";
import { Tooltip } from "components/styles";
//#endregion


const StudentTableListItem = ({
    data, isResponsable,
    studentsSelected,
    getInfoTooltipOfPenalize,
    formList
}) => {
    const {
        id, name,
        attended, penalty,
        saved, forTakeAttendance,
        forPenalize
    } = data;
    //#region States
    const [infoTooltip, setInfoTooltip] = useState({
        active: false,
        position: { top: 0, left: 0 }
    });
    const [infoTooltipOfPenalize, setInfoTooltipOfPenalize] = useState(null);
    //#endregion
    //#region Hooks
    const $stateCell = useRef();
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!penalty && !forPenalize) return;
        setInfoTooltipOfPenalize(getInfoTooltipOfPenalize({ studentId: id, penalty }));
    }, [formList]);
    //#endregion
    //#region Functions
    const getStudentColorText = () => {
        if (!saved) return "var(--purple-2)";
        return isResponsable ? "var(--dark-4)" : "var(--light-gray-5)";
    }
    const toggleActiveInfoTooltip = (e, active) => {
        setInfoTooltip(prev => ({
            ...prev,
            active
        }));
        if (!active) return;
        const $element = e.target;
        const { x, y } = $element.getBoundingClientRect();
        setInfoTooltip(prev => ({
            ...prev,
            position: {
                left: `${x}px`,
                top: `${y}px`
            }
        }));
    }
    const toggleActiveInfoTooltipHandlers = {
        onMouseEnter: e => toggleActiveInfoTooltip(e, true),
        onMouseLeave: e => toggleActiveInfoTooltip(e, false)
    };
    //#endregion
    const student = `${name} (${id})`;
    return (
        <tr> 
            <td>
                <StudentCell>
                    <BodyRowText 
                        color={getStudentColorText()}>
                        <span title={student}>{student}</span>
                    </BodyRowText>
                </StudentCell>
            </td>
            <td>
                <StateCell 
                    ref={$stateCell}
                    justify={!saved ? "center" : "flex-start"}>
                    {(attended || forTakeAttendance) && (
                        <span data-type="attendance">
                            <UserIcon2 variant="check"/>
                        </span>
                    )}
                    {(penalty || forPenalize) && (
                        <span data-type="penalty" {...toggleActiveInfoTooltipHandlers}>
                            <UserIcon2 variant="cross"/>
                        </span>
                    )}
                    {!saved && (
                        <span {...toggleActiveInfoTooltipHandlers}>
                            <WarningIcon/>
                        </span>
                    )}
                </StateCell>
                {!saved &&
                <Tooltip 
                    className={infoTooltip.active ? "active" : ""}
                    {...infoTooltip.position}
                    x="15%" y="-62%"
                    position="fixed"
                    after={{
                        x: "-610%", y: "-220%",
                        angle: "135deg"
                    }}
                    width="230px">
                    <span>Debes guardar información para poder marcar asistencia o sancionar al alumno.</span>
                </Tooltip>}
                {(penalty || forPenalize) && 
                <Tooltip 
                    className={infoTooltip.active ? "active" : ""}
                    {...infoTooltip.position}
                    position="fixed"
                    x="16%" y="-68%"
                    after={{
                        x: "-610%", y: "-220%",
                        angle: "135deg"
                    }}
                    width="230px">
                    {infoTooltipOfPenalize && 
                    <>
                    <span>Motivo: {infoTooltipOfPenalize.reason}</span><br/>
                    <span>Días de sanción: {infoTooltipOfPenalize.penalizeDays}</span><br/>
                    <span className="ellipsis">Detalle: {infoTooltipOfPenalize.details}</span>
                    </>}
                </Tooltip>}
            </td>
            <td>
                <SelectionCell>
                    <CustomCheckbox 
                        checked={studentsSelected.isSelected(data)}
                        onChange={() => studentsSelected.toggle(data)}
                        padding="6px 10px"/>
                </SelectionCell>
            </td>
        </tr>
    );
}

export default StudentTableListItem;